import axios from 'axios'
import i18n from '../i18n'

const queryString = require('query-string')

// Create plugin
const api = axios.create({
  baseURL: process.env.VUE_APP_API_ROOT,
  paramsSerializer: function (params) {
    return queryString.stringify(params, {
      encode: false,
    })
  },
})

// Request interceptor
api.interceptors.request.use(function (config) {
  // Add locale
  config.params = {
    ...config.params,
    lang: i18n.locale,
  }

  return config
}, function (error) {
  return Promise.reject(error)
})

// Response interceptor
api.interceptors.response.use(response => {
  return Promise.resolve(response)
}, function (error) {
  return Promise.reject(error)
})

// JSON api
const jsonApi = axios.create({
  baseURL: process.env.VUE_APP_JSON_API_ROOT,
})

// Export Vue plugin
export default {
  ...api,
  install (Vue) {
    Vue.prototype.$axios = axios
    Vue.prototype.$api = api
    Vue.prototype.$jsonApi = jsonApi
  },
}
